module.exports = __webpack_public_path__ + "static/img/logo.36739599.png";